function setDeliveryRatesExpanded(root, expanded) {
    const toggle = root.querySelector('[data-delivery-rates-toggle]');
    const collapse = root.querySelector('[data-delivery-rates-collapse]');
    if (!toggle || !collapse) return;

    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    collapse.setAttribute('aria-hidden', expanded ? 'false' : 'true');
    root.classList.toggle('delivery-rates--open', expanded);
}

function initDeliveryRatesRoot(root) {
    const toggle = root.querySelector('[data-delivery-rates-toggle]');
    if (!toggle) return;

    const openFromHash = () => window.location.hash === '#rate';
    const shouldOpen = openFromHash();
    setDeliveryRatesExpanded(root, shouldOpen);

    if (shouldOpen) {
        root.scrollIntoView({behavior: 'smooth', block: 'start'});
    }

    toggle.addEventListener('click', (event) => {
        event.preventDefault();
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        setDeliveryRatesExpanded(root, !isExpanded);
    });
}

export function initDeliveryLiftRates() {
    document.querySelectorAll('[data-delivery-rates]').forEach(initDeliveryRatesRoot);

    window.addEventListener('hashchange', () => {
        if (window.location.hash !== '#rate') return;

        document.querySelectorAll('[data-delivery-rates]').forEach((root) => {
            setDeliveryRatesExpanded(root, true);
            root.scrollIntoView({behavior: 'smooth', block: 'start'});
        });
    });
}
